<script setup lang="ts">
import { useContactStore } from '@/stores/contact.store';

const contactStore = useContactStore();

const contact = contactStore.getContact;
</script>

<template>
  <footer>
    <img src="/assets/icons/logo-gray.svg" alt="АЭБ" />
    <div class="info">
      <p>ДЛЯ ДОПОЛНИТЕЛЬНОЙ ИНФОРМАЦИИ СВЯЖИТЕСЬ С НАМИ</p>
      <a :href="`tel:${contact?.phone}`">+{{ contact?.phone }}</a>
      <a :href="`mailto:${contact?.email}`">{{ contact?.email }}</a>
    </div>
  </footer>
</template>

<style scoped lang="scss">
footer {
  gap: 42px;
  display: flex;
  margin: 100px 0 40px;
  padding: 40px 0;
  align-items: center;
  border-radius: 40px;
  flex-direction: column;
  justify-content: center;
  font-size: var(--font-size-s);
  color: var(--color-mono-800);
  background: var(--color-mono-10);
  font-weight: var(--font-weight-medium);

  nav {
    gap: 64px;
    display: flex;

    @media screen and (max-width: 1024px) {
      gap: 24px;
      text-align: center;
      flex-direction: column;
    }

    a {
      padding: 12px;
      cursor: pointer;
      transition: 0.3s;
      color: var(--color-mono-800);

      @media (hover: hover) {
        &:hover {
          color: #035de3;
        }
      }
    }
  }

  img {
    height: 48px;
    user-select: none;

    @media screen and (max-width: 600px) {
      height: 38px;
    }
  }

  .info {
    gap: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;

    @media screen and (max-width: 1024px) {
      text-align: center;
    }

    * {
      color: var(--color-mono-800);
      padding: 4px 12px;
      text-transform: uppercase;
    }
  }
}
</style>
